import type { Store } from 'vuex'

export const logBootTime = (store: Store<Record<string, unknown>>) => {
  store.dispatch('PayHub/logDiagnostics', {
    event: 'timing-install-finished',
    duration: window.performance.now(),
  })
}
